import React, { useEffect, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import QuestionPreview from './QuestionPreview'
import styled from 'styled-components'
import { Form } from 'semantic-ui-react'
import { formatNumberWithoutFractions } from '~/utils/helpers'

interface SliderProps {
  languageIndex: number
}

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SliderC = styled.input.attrs({
  type: 'range'
}) <{ rating?: number }>`
  flex: 1;
  margin: 0 10px;
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background: linear-gradient(to right, ${props => props.theme.firstColor} 0%, ${props => props.theme.firstColor} ${(props) => props.rating}%, #EDEFF1 ${(props) => props.rating}%, #EDEFF1 100%);
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${props => props.theme.firstColor};
    cursor: pointer;
  }

  &::-webkit-slider-runnable-track {
   
  }

  &:hover {
    opacity: 1;
  }

  &:active::-webkit-slider-thumb {
    background-color: ${props => props.theme.secondColor};
  }
`;

export const MinMaxLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
`;

export const MinValueLabel = styled(MinMaxLabel)`
  margin-right: 10px;
`;

export const MaxValueLabel = styled(MinMaxLabel)`
  margin-left: 10px;
`;

const Slider: React.FC<SliderProps> = (props) => {
  const { languageIndex } = props
  const { t } = useTranslation()
  const { control, getValues } = useFormContext()
  const [rating, setRating] = useState(0);
  const watchQuestions = useWatch({ control, name: `languages[${languageIndex}].question` })
  const watchMin = useWatch({ control, name: 'minValue' })
  const watchMax = useWatch({ control, name: 'maxValue' })
  const watchReq = useWatch({ control, name: 'required' })
  const watchInterval = useWatch({ control, name: 'interval' })
  const watchUnit = useWatch({ control, name: `languages[${languageIndex}].unitLabel` }) || ''

  useEffect(() => {
    setRating(watchMin)
  }, [watchMax, watchMin])

  function renderForm() {
    return <>
      <FormFields.TextArea
        control={control}
        label={t('Type in your question')}
        placeholder={t('Type in your question')}
        name={`languages[${languageIndex}].question`}
        rules={{
          required: {
            value: true,
            message: t('Please enter question')
          }
        }}
      />
      <FormFields.Input
        control={control}
        label={t('Units (kg, l, %, €, $)')}
        placeholder={t('Units (kg, l, %, €, $)')}
        name={`languages[${languageIndex}].unitLabel`}
      />
    </>
  }

  const handleChange = (event) => {
    setRating(event.target.value);
  };

  function renderPreview() {
    const min = getValues('minValue')
    const max = getValues('maxValue')
    return <QuestionPreview>
      <Form.Field label={watchQuestions} required={Boolean(watchReq)} />
      <Form.Field label={t('Rating: {{rating}} {{watchUnit}}', { rating: formatNumberWithoutFractions(rating), watchUnit })} />
      <SliderWrapper>
        <MinValueLabel>{`${formatNumberWithoutFractions(min)} ${watchUnit}`}</MinValueLabel>
        <SliderC
          step={watchInterval}
          rating={((rating - min) / (max - min)) * 100}
          min={min}
          max={max}
          value={rating}
          onChange={handleChange}
        />
        <MaxValueLabel>{`${formatNumberWithoutFractions(max)} ${watchUnit}`}</MaxValueLabel>
      </SliderWrapper>
    </QuestionPreview>
  }

  return <>
    {renderForm()}
    {renderPreview()}
  </>
}
export default Slider